import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#663399" },
    secondary: { main: "#FF8C00" },
    background: { default: "#0f0f14", paper: "#1a1a24" },
    success: { main: "#22c55e" },
    warning: { main: "#f59e0b" },
    error: { main: "#ef4444" },
  },
  typography: {
    fontFamily: '"Inter", "SF Pro Display", system-ui, sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(255,255,255,0.06)",
        },
      },
    },
    MuiChip: {
      styleOverrides: { root: { fontWeight: 600 } },
    },
  },
});

export const TIER_COLORS: Record<string, string> = {
  diamond: "#00D4FF",
  gold: "#FFD700",
  silver: "#C0C0C0",
  bronze: "#CD7F32",
};

export const STATUS_COLORS: Record<string, string> = {
  pending: "#f59e0b",
  matched: "#8b5cf6",
  dispatched: "#a855f7",
  accepted: "#3b82f6",
  en_route: "#06b6d4",
  arrived: "#10b981",
  in_progress: "#22c55e",
  completed: "#6b7280",
  couldnt_fix: "#ef4444",
  needs_revisit: "#f97316",
  cancelled: "#ef4444",
};
